import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const TOKEN_KEY = "neptune_admin_token";

export const tokenStore = {
  get: () => {
    try { return localStorage.getItem(TOKEN_KEY); } catch { return null; }
  },
  set: (token) => {
    try { localStorage.setItem(TOKEN_KEY, token); } catch { /* ignore */ }
  },
  clear: () => {
    try { localStorage.removeItem(TOKEN_KEY); } catch { /* ignore */ }
  },
};

const api = axios.create({
  baseURL: `${BACKEND}/api`,
  withCredentials: true,
});

// Inject Authorization: Bearer <token> when available — fallback for browsers
// that block third-party cookies (Safari ITP, strict mode, etc).
api.interceptors.request.use((config) => {
  const token = tokenStore.get();
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;
export { BACKEND };
